"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spaceUnit = 4;
const minhalojaeudora = {
    name: 'Eudora',
    useNextVariants: true,
    suppressDeprecationWarnings: true,
    palette: {
        primary: { main: '#472d75' },
        secondary: { main: '#6f42b6' },
        tertiary: { main: '#ed676d' },
        success: { main: '#23B218' },
        warning: { main: '#FF9700' },
        error: { main: '#DE1616' },
        neutral: {
            'ultra-dark': '#000000',
            dark: '#515151',
            medium: '#878787',
            light: '#f5f5f5',
            'ultra-light': '#ffffff',
        },
        conversion: {
            static: 'linear-gradient(266.86deg, #E0BF6B 0%, #C89A41 100%);',
            hover: '#C89A41',
            disabled: 'rgba(0, 0, 0, 0.16)',
        },
        navigation: {
            static: '#6F42B6',
            hover: '#472D75',
            disabled: 'rgba(0, 0, 0, 0.16)',
        },
        contrast: {
            static: '#FFF',
            hover: '#E5C5C6',
            disabled: 'rgba(255, 255, 255, 0.24);',
        },
        status: {
            success: '#23B218',
            alert: '#FF9700',
            error: '#DE1616',
        },
        support: {
            green: {
                main: '#128C7E',
                dark: '#005e52',
            },
            blue: {
                main: '#0078FF',
                dark: '#004dcb',
            },
        },
    },
    typography: {
        fontFamily: ['Myriad Pro', 'Open Sans', 'Times new roman', 'Arial ', 'serif'].join(','),
        primary: 'Myriad Pro',
        secondary: 'Open Sans',
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 600,
        fontWeightBold: 800,
    },
    spacing: (value) => value * spaceUnit,
    shadows: [
        '0',
        '0px 8px 16px -8px rgba(0, 0, 0, 0.32)',
        '0px 16px 32px -8px rgba(0, 0, 0, 0.4)',
        '0px 0px 16px -8px rgba(0, 0, 0, 0.16)',
    ],
    mixins: {
        gutters: (styles = {}) => (Object.assign(Object.assign({}, styles), { paddingLeft: 0, paddingRight: 0, paddingTop: 0, paddingBottom: 0, margin: '0 0 0 0' })),
    },
    overrides: {
        MuiFormControl: {
            marginNormal: {
                marginTop: 0,
                marginBottom: 0,
            },
        },
        MuiLink: {
            underlineHover: {
                textDecoration: 'underline',
            },
        },
        MuiButton: {
            contained: {
                boxShadow: 'none',
            },
        },
        MuiFormHelperText: {
            root: {
                marginTop: '4px',
                fontStyle: 'normal',
                fontWeight: 'normal',
                fontSize: '12px',
                lineHeight: '16px',
            },
            contained: {
                marginLeft: '0px',
                marginRight: '0px',
            },
        },
    },
};
exports.default = minhalojaeudora;
